<div class="btn-group btn-group-sm" role="group" *ngIf="!showCustomInputs; else customInputs">
  <button type="button"
          class="btn"
          [class.btn-success]="activeFilter === 'thisMonth'"
          [class.btn-outline-success]="activeFilter !== 'thisMonth'"
          (click)="selectPreset('thisMonth')">
    This Month
  </button>
  <button type="button"
          class="btn"
          [class.btn-success]="activeFilter === 'lastMonth'"
          [class.btn-outline-success]="activeFilter !== 'lastMonth'"
          (click)="selectPreset('lastMonth')">
    Last Month
  </button>
  <button type="button"
          class="btn"
          [class.btn-success]="activeFilter === 'custom'"
          [class.btn-outline-success]="activeFilter !== 'custom'"
          (click)="openCustom()">
    Custom
  </button>
</div>

<ng-template #customInputs>
  <div class="d-flex align-items-center flex-wrap">
    <label class="mb-0 mr-2 small text-muted">From:</label>
    <input type="date" class="form-control form-control-sm mr-2" style="width: auto;" [(ngModel)]="customStartDate">
    <label class="mb-0 mr-2 small text-muted">To:</label>
    <input type="date" class="form-control form-control-sm mr-2" style="width: auto;" [(ngModel)]="customEndDate">
    <button type="button" class="btn btn-sm btn-success mr-1" (click)="applyCustom()">Filter</button>
    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeCustom()" title="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>
</ng-template>
